import Immutable from 'immutable';

export type ConnectedAccountId = string;
export interface RawConnectedAccount {
  id: string;
  label: string;
  ownerId: string;
  providerType: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  isExpired: boolean;
}

export interface ConnectedAccountData {
  id: string;
  label: string;
  ownerId: string;
  providerType: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  isExpired: boolean;
}

const defaultValues: ConnectedAccountData = {
  id: '',
  label: '',
  ownerId: '',
  providerType: '',
  createdAt: '',
  updatedAt: '',
  expiresAt: '',
  isExpired: false,
};

export const ConnectedAccountFactory = Immutable.Record(
  defaultValues,
  'ConnectedAccount'
);

export type ConnectedAccountMap = Immutable.OrderedMap<
  ConnectedAccountId,
  ConnectedAccount
>;
export type ConnectedAccountList = Immutable.List<ConnectedAccount>;

export class ConnectedAccount extends ConnectedAccountFactory {
  static deserialize(
    rawConnectedAccount: RawConnectedAccount
  ): ConnectedAccount {
    return new ConnectedAccount({
      ...rawConnectedAccount,
    });
  }

  serialize(): RawConnectedAccount {
    return this.toJS();
  }
}
